import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { QuestionListModel } from 'app/question/models/question-list.model';
import { QuestionService } from 'app/question/services/question.service';
import { QuestionBankQuestionListModel } from 'app/question/models/question-bank-question-list.model';

@Component({
    selector: 'app-question-bank-question-add',
    templateUrl: './question-bank-question-add.component.html',
    styleUrls: ['./question-bank-question-add.component.css']
})

export class QuestionBankQuestionAddComponent implements OnInit {
    errors: string[];
    auditTypes: AuditTypeModel[];
    questions: QuestionListModel[];
    addQuestionBankQuestionForm: FormGroup;
    submitAttempt: boolean = false;
    @Input() questionBankId: string;
    @Input() isEditMode: boolean = false;
    @Output() questionBankQuestionAdded: EventEmitter<string> = new EventEmitter<string>();
    questionBankQuestions: QuestionBankQuestionListModel[];

    constructor(
        private questionService: QuestionService,
        private auditService: AuditService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();
        this.getQuestions();

        this.questionService.getQuestionBankQuestions(this.questionBankId).subscribe(
            questionBankQuestions => {
                this.questionBankQuestions = questionBankQuestions;
                this.initializeForm();
            },
            error => this.errors = error.errorList
        );
    }

    ngAfterViewInit(): void {

    }

    initializeForm(): void {
        this.addQuestionBankQuestionForm = this.fb.group({
            questionBankId: [this.questionBankId],
            questionId: ['', Validators.required],
            auditTypeId: [''],
            zOrder: [this.questionBankQuestions.length + 1, Validators.required],
            isMandatory: [true, Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    getQuestions(): void {
        this.questionService.getAll().subscribe(result => {
            this.questions = result;
        });
    }

    addQuestionToQuestionBank(): void {
        this.submitAttempt = true;

        if (this.addQuestionBankQuestionForm.valid) {
            const formValue = this.addQuestionBankQuestionForm.value;
            this.questionService.addQuestionBankQuestion(formValue).subscribe(
                result => {
                    this.questionBankQuestionAdded.emit(result);
                    //this.addQuestionBankQuestionForm.reset();
                    //this.addQuestionBankQuestionForm.patchValue({ "questionBankId": this.questionBankId, "isMandatory": false });
                    this.initializeForm();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');

                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddQuestion(content) {
        this.modalService.open(content);
    }
}
